
import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
import Axios from 'axios';
import Swal from "sweetalert2";
import { API_BASE_URL, INSERT_CATEGORY } from '../../../Config';
import SpinLoader from '../../../feature-module/loader/SpinLoader';

const AddCategoryList = () => {

    const [userDataSession, setUserDataSession] = useState([]);
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);

        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    const initialFormData = {
        OrgId: userDataSession.OrgId,
        CreatedBy: userDataSession.UserId,
        Name: "",
        Code: "",
        Description: "",
        IsDefault: false,
        ImagePath: "",
        ImageUrl: ""
    };

    const [formData, setFormData] = useState(initialFormData);

    const handleCancel = () => {
        setFormData(initialFormData);
    };
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
        validateInput(value);
    };    

    const fetchAndUpdateSessionData = () => {
        if (userDataSession && userDataSession.OrgId) {
          Axios.get(`${API_BASE_URL}Admin/getDDl?&LoggedInUser=${userDataSession.UserId}&OrgId=${userDataSession.OrgId}`)
            .then(response => {
              if (response.data) {
                const allData = response.data.ResultData;
      
                // Define the DDL names to filter
                const ddlNames = ['Supplier', 'CATEGORY', 'Subcategories', 'Products', 'variantypes', 'TAX', 'Stores', 'BRAND', 'UNITS'];
      
                // Iterate through each DDL name, filter data, and save to session storage
                ddlNames.forEach(name => {
                  const filteredData = allData.filter(item => item.DDLName === name);
                  sessionStorage.setItem(`filteredDDLData_${name}`, JSON.stringify(filteredData));
                });
      
                console.log('Filtered data saved successfully');
              } else {
                console.error('Error fetching data:', response.data);
              }
            })
            .catch(error => {
              console.error('Error fetching data:', error);
            });
        }
      };
      

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnLoading(true);
        let updatedFormData = { ...formData };
      
        updatedFormData.CreatedBy = userDataSession.UserId;
        updatedFormData.OrgId = userDataSession.OrgId;
        updatedFormData.ImagePath = "NULL";
        updatedFormData.ImageUrl = "NULL";
        updatedFormData.Description = formData.Description === "" ? "NULL" : formData.Description;
        updatedFormData.Calc = formData.Calc == null ? "NULL" : formData.Calc;
        updatedFormData.IsDefault = formData.IsDefault == true ? 1 : 0;
        console.log(updatedFormData, 'data to api');
      
        Axios.post(`${API_BASE_URL}${INSERT_CATEGORY}`, updatedFormData)
            .then(response => {
                console.log(response.data.ResultData);
                console.log(response.data.ResultData[0]['Status'] == 'Success');
      
            if (response.data.ResultData[0]['Status'] == 'Success') {
              setSubmitBtnLoading(false);
      
              // Fetch and update session data
              fetchAndUpdateSessionData();
      
              // Show success message
              Swal.fire({
                title: `Category added Successfully.`,
                icon: "success",
              }).then((result) => {
                // Reload the page after the user acknowledges the success message
                if (result.isConfirmed || result.isDismissed) {
                  window.location.reload();
                }
              });
            } else {
              setSubmitBtnLoading(false);
      
              Swal.fire({
                title: "Error",
                text: "Failed to Request Submit.",
                icon: "error",
              });
            }
          })
          .catch(error => {
            setSubmitBtnLoading(false);
            // Handle error
            console.error('Error adding category:', error);
          });
      };

      const validateInput = (value) => {
        const specialCharPattern = /[!@#$%^&*(),.?"';:{}|<>]/g;
        if (specialCharPattern.test(value)) {
          setError('Special characters are not allowed.');
        } else {
          setError('');
        }
      };
      
    return (
        <div>{(submitBtnLoading)&&(<SpinLoader/>)}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightCategoryAdd"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: '400px' }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Add Category</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Name<span className="fw-bold text-danger">*</span></label>
                            <input
                                type="text"
                                placeholder='Category type'
                                className="form-control"
                                name="Name"
                                value={formData.Name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        
                        <div className="mb-0">
                            <div className="mb-3">
                                <label className="form-label">Code<span className="fw-bold text-danger">*</span></label>
                                <input
                                    type="text"
                                    placeholder='Category Code'
                                    className="form-control"
                                    name="Code"
                                    value={formData.Code}
                                    onChange={handleChange}
                                    maxLength={5}
                                    required
                                />
                            </div>
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Description</label>
                            <textarea
                                type="text"
                                placeholder='Enter notes'
                                className="form-control"
                                name="Description"
                                value={formData.Description}
                                onChange={handleChange}
                            ></textarea>
                        </div>
                        <div className="mb-0">
                            <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                <span className="status-label">IsDefault</span>
                                <input
                                    type="checkbox"
                                    id="user2"
                                    className="check"
                                    name="IsDefault"
                                    checked={formData.IsDefault}
                                    onChange={handleChange}
                                />
                                <label htmlFor="user2" className="checktoggle"></label>
                            </div>
                            {error && <div className="text-danger mt-2">{error}</div>}
                        </div>
                        <div className="modal-footer-btn">
                            <button
                                type="button"
                                className="btn btn-cancel me-2"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                                onClick={handleCancel}
                                 disabled={submitBtnLoading}
                            >
                                Cancel
                            </button>
                            <button type='submit' className="btn btn-submit"
                             disabled={submitBtnLoading}>
                                {submitBtnLoading ? 'Submitting..' : 'Submit'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddCategoryList
